// 中止结算池
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <!-- <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle"></editView>
      </el-tab-pane> -->
      <el-tab-pane label="列表" name="second">

        <div  class="grid-height"  style="height: calc(100vh - -75px);">
          <vxe-grid show-overflow border="default"  height="100%" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
          >

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button v-if="suspendPoolExport" status="primary" class="button-sty" icon="el-icon-top" @click="doExcle">导出
                  </vxe-button>
                  <el-button v-if="batchIntoSettlePool" type="primary" plain class="button-sty" @click="toBatch"
                             icon="el-icon-location-information">批量重进结算池
                  </el-button>

                  <el-button v-if="settleRetryServiceFeeButton" type="primary" plain class="button-sty" @click="toRetryServiceFee"
                             icon="el-icon-location-information">批量重算服务费
                  </el-button>

                </div>
                <div class="fr">
                  <el-input type="textarea"
                            :autosize="{ minRows: 1, maxRows: 3}" style="width: 200px;     height: 27px !important; " @keyup.enter.native="searchEvent"
                            v-model="formData.orderNoArr" placeholder="请输入工单号" clearable>
                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                  </el-input>
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;"
                              class="button-sty" @click="searchEvent">搜索
                  </vxe-button>


                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form  ref="form" class="screen-box" title-width="7vw"
                          title-align="right" :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent" >

                  <vxe-form-item title="工单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.orderNo"  style="width: 16vw!important;"  clearable/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="服务商:" field="name">
                    <template v-slot>
                      <el-autocomplete
                        class="inline-input"
                        style="width: 16vw!important;"
                        v-model="formData.siteName"
                        :fetch-suggestions="querySiteSearch"
                        placeholder="请输入内容"
                        :trigger-on-focus="false"
                        @select="handleSiteSelect" clearable
                      ></el-autocomplete>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="预审项目:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.preconditionId" placeholder="预审项目" style="width: 24vw!important;" clearable>
                        <el-option v-for="item in preconditionOption" :key="item.precondition"
                                   :label="item.precondition" :value="item.preconditionId" />
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="完工时间:" field="name" >
                    <template v-slot style=" display: inline-block;">
                      <el-date-picker  v-model="formData.completeTime" type="daterange" align="right" unlink-panels
                                       style="width: 16vw!important;"
                                       range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                       :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="回访时间:" field="name" >
                    <template v-slot style=" display: inline-block;">
                      <el-date-picker  v-model="formData.recallFinishTime" type="daterange" align="right" unlink-panels
                                       style="width: 16vw!important;"
                                       range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                       :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                </vxe-form>
              </el-collapse-transition>

            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
<!--            <template #option="{row}">
              <div>
                <el-dropdown @command="handleCommand($event, row)" >
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon&#45;&#45;right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="row.stat == 64 && intoSettlePoolButton" command="3">进入结算池</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>-->
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <closeDialog v-if="showCloseDialog"
                 :close-id="dataId"
                 @closeD="closeD"
                 :visiable.sync="showCloseDialog"
                 multi="true"
                 @flushed="editViewDataUpdate"
    />
    <detailsDialog v-if="showDetailsDialog" @closeD="(v) => {showDetailsDialog=v}" :row1="dataId"
                   :visiable.sync="showDetailsDialog"
                   multi="true"/>
  </div>
</template>

<script>
import store from "@/store";
import editView from './edit.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";
import closeDialog from "@/views/workorder/accounts/pool/closeDialog.vue";
import detailsDialog from "@/views/dialogCommon/detailsDialog.vue";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";

export default {
  name: 'pool',

  inject: ['reload'],
  components: {detailsDialog, editView, pager,closeDialog},
  data() {
    return {
      total: 0,
      searchValue: null,
      showPage: true,
      showCloseDialog: false,
      intoSettlePoolButton: false,
      settleRetryServiceFeeButton: false,
      batchIntoSettlePool: false,
      suspendPoolExport: false,
      showDetailsDialog: false,
      requestParam: {
        stat: null,
        orderNo: null,
        orgId: null,
        siteId: null,
        checkNo: null,
        invoiceNo: null,
        fuzzySearchIsEnable: false,
        fuzzySearchValue: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        recallFinishTimeBegin:null,
        recallFinishTimeEnd:null,
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        tabStat:'待进入',
        guaranteeType: null,
        preconditionId: null,
        orderNoArr: null
      },

      formData: {
        stat: null,
        orderNo: null,
        orgId: null,
        siteId: null,
        checkNo: null,
        invoiceNo: null,
        createTime: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeTime: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        recallFinishTime:null,
        recallFinishTimeBegin:null,
        recallFinishTimeEnd:null,
        siteName: null,
        guaranteeType: 1,
        preconditionId: null,
        orderNoArr: null
      },
      show3: false,

      sitePromptList: [],
      preconditionOption: [],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      // 查询参数


      pageSizes: [10, 20, 100],

      showEdit: false,

      //工单号、工单状态、工单来源、服务类型、保修类型、购买渠道、产品大类、网点金额、服务中心、一级服务商、服务商、创建单、完工时间、回访时间;


    columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {
          width: 60,
          field: 'status',
          fixed: 'right',
          title: '操作',
          showOverflow: true,
          /*slots: {
            default: 'option'

          }*/
        },
        // { title: '工单号', field: 'orderNo', width: 190,},
        {title: '工单号', field: 'orderNo', width: 190, slots: {
            default: ({row}) => {
              return [
                <span style="color: blue; cursor: pointer"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.orderNo}</span>
              ]
            }
          }
        },
        {title: '工单状态', field: 'orderStat', width: 125, slots: {
            default: ({row}) => {
              if (row.stat == 93) {
                return [
                  <div class="txt-status disable">
                    <span>结算中止</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '工单来源', field: 'orderTypeName', width: 100, },
        { title: '服务类型',field: 'serviceTypeName', width: 100,},
        { title: '保修类型', field: 'guaranteeType', width: 125, slots: {
            default: ({row}) => {
              if (row.guaranteeType == 1) {
                return [
                  <div class="txt-status disable">
                    <span>保内</span>
                  </div>
                ];
              } else if (row.guaranteeType == 2) {
                return [
                  <div class="txt-status ">
                    <span>保外</span>
                  </div>
                ];
              }else if (row.guaranteeType == 3) {
                return [
                  <div class="txt-status ">
                    <span>未知</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '购买渠道', field: 'buyChannelName', width: 100, },
        { title: '产品大类', field: 'bigCategoryName', width: 100, },
        { title: '网点金额', field: 'siteAmount', width: 80, },
        { title: '服务中心',field: 'orgName', width: 100,},
        { title: '一级服务商',field: 'bigSiteName', width: 100,},
        { title: '服务商', field: 'siteName', width: 100, },
        { title: '创建时间', field: 'createTime', width: 150, },
        { title: '完工时间', field: 'completeTime', width: 150, },
        { title: '回访时间', field: 'recallTime', width: 150, },
      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    'formData.siteName': {
      handler(newVal) {
        if (!newVal) {
          this.formData.siteId = null
        }
      },
      deep: true
    },
    'formData.createTime': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.recallFinishTime': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.recallFinishTimeBegin = newVal[0]
          this.formData.recallFinishTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.recallFinishTimeBegin = null
          this.formData.recallFinishTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.completeTime': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.completeTimeBegin = newVal[0]
          this.formData.completeTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.completeTimeBegin = null
          this.formData.completeTimeEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    this.suspendPoolExport = this.permissions["suspendPoolExport"];//导出
    this.batchIntoSettlePool =  this.permissions["batchIntoSettlePool"];//批量重进结算池
    this.settleRetryServiceFeeButton =  this.permissions["settleRetryServiceFeeButton"];//批量重算服务费
    console.log(this.intoSettlePoolButton,"this.intoSettlePoolButton的素质");
  },

  mounted() {
    this.initSearchDate()
    this.loadPreconditionOptions()
  },

  methods: {
    //加载预审项目
    loadPreconditionOptions() {
      this.$http({
        url: api.fwpttenant.getPreconditionByTenantId,
        method: 'post',
        data: {}
      }).then(res => {
        this.preconditionOption = res.data.data
        console.log("preconditionOption",this.preconditionOption)
      })
    },

    //导出
    doExcle(){
      this.$mask.open()
      doCheckExcle(fileNames.suspendPool).then(response => {
        if (response.data.type=="success"){
          doDownLoadExcle(api.soApplyMoneySuspend.doExcelUrl, this.formData).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
          this.$mask.close()
        }else{
          this.$mask.close()
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },
    editViewDataUpdate() {
      this.$emit('editViewDataUpdate')
      this.$emit('changeTab')
    },
    //抽屉关闭后改变父组件的visible的值
    closeD(v) {
      this.showCloseDialog = false
      // this.flushed()
    },
    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.completeTime = [start, end]
      this.requestParam.completeTimeBegin = start
      this.requestParam.completeTimeEnd = end
    },

    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },


    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },

    serviceTypeHandleChange(data) {
      console.log('选中的服务类型数据', data)
    },

    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.soApplyMoney.getSuspendTableDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 重置
    resetEvent() {
      this.formData = {
        feeType: '',
        name: ''
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.name = ''
      this.requestParam.feeType = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },





    ///////////////////////////////////////////////////////////////////////////////////////////////////
    toRetryServiceFee(){
      let orderIds =[];
      const checkIds =this.$refs['table-m1'].getCheckboxRecords();
      if (checkIds.length==0){
        this.$message.error('请先选择需要批量重算工单金额的单据！')
        return
      }
      for (let i = 0; i < checkIds.length; i++) {
        orderIds.push(checkIds[i].id)
      }
      this.orderIds = orderIds;

      this.$confirm( '是否确认批量重算工单金额?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$mask.open()
        this.$http({
          url: api.soApplyMoney.toRetryServiceFee,
          method: 'post',
          data: {
            orderIds: orderIds
          },
        }).then(res => {
          if(res.data.data){
            this.$message.success('操作成功')
            this.$mask.close()
            this.flushed()// 需要刷新页面
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
      this.$mask.close()
    },

    toBatch(){
      let orderIds =[];
      const checkIds =this.$refs['table-m1'].getCheckboxRecords();
      if (checkIds.length==0){
        this.$message.error('请先选择需要批量进入结算池的单据！')
        return
      }
      for (let i = 0; i < checkIds.length; i++) {
        orderIds.push(checkIds[i].id)
      }
      this.orderIds = orderIds;

      this.$confirm( '是否确认批量进入结算池?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$mask.open()
        this.$http({
          url: api.soApplyMoney.batchAgainIntoSettlementPool,
          method: 'post',
          data: {
            orderIds: orderIds
          },
        }).then(res => {
          if(res.data.data){
            this.$message.success('操作成功')
            this.$mask.close()
            this.flushed()// 需要刷新页面
          }
        }).catch(() => {
          this.$mask.close()
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
      this.$mask.close()
    },
    // 选中的按钮
    addressClickEvent(row) {
      console.log(row, 'row')
      this.dataId = row.id
      this.showDetailsDialog = true
    },
    // 打开操作弹窗
    handleCommand(b,row) {
      if (b == 1) {
        this.dataId = row.id
        this.cancelSettle()
      } else if (b == 2) {
        this.open()
      }else if (b == 3) {
        this.intoSettlePool(row.orderNo)
      }
    },

    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.flushed()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.flushed()// 需要刷新页面
      });

    },

    intoSettlePool(orderNo) {
      this.$confirm( '是否进入结算池?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$mask.open()
        this.$http({
          url: api.soApplyMoney.addByOrderNo,
          method: 'post',
          data: {
            orderNo: orderNo
          },
        }).then(res => {
          this.$message({
            type: res.data.type,
            message: res.data.content
          });
          this.$mask.close()
          this.flushed()// 需要刷新页面
        }).catch(() => {
          this.$mask.close()
        });
      }).catch(() => {
        this.$mask.close()
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
      this.$mask.close()
    },


    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    cancelSettle(){
      this.showCloseDialog = true;
    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },


    // 新增
    openEditDialog(id) {

      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },


  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
::v-deep .vxe-grid .el-input .el-input__inner {
    height: 28px !important;
}
</style>
